export default [
  {
    value: "",
    text: "Select Your University"
  },
  {
    value: "Abia State University",
    text: "Abia State University"
  },

  {
    value: "Abubakar Tafawa Balewa University",
    text: "Abubakar Tafawa Balewa University"
  },

  {
    value: "Achievers University",
    text: "Achievers University"
  },

  {
    value: "Adamawa State University",
    text: "Adamawa State University"
  },

  {
    value: "Adekunle Ajasin University",
    text: "Adekunle Ajasin University"
  },

  {
    value: "Afe Babalola University",
    text: "Afe Babalola University"
  },

  {
    value: "Ahmadu Bello University",
    text: "Ahmadu Bello University"
  },

  {
    value: "Ajayi Crowther University",
    text: "Ajayi Crowther University"
  },

  {
    value: "Akwa Ibom State University",
    text: "Akwa Ibom State University"
  },

  {
    value: "Al-Hikmah University",
    text: "Al-Hikmah University"
  },

  {
    value: "Ambrose Alli University",
    text: "Ambrose Alli University"
  },

  {
    value: "American University of Nigeria",
    text: "American University of Nigeria"
  },

  {
    value: "Anambra State University",
    text: "Anambra State University"
  },

  {
    value: "Babcock University",
    text: "Babcock University"
  },

  {
    value: "Bakassi Technical University",
    text: "Bakassi Technical University"
  },

  {
    value: "Bayero University",
    text: "Bayero University"
  },

  {
    value: "Bells University of Technology",
    text: "Bells University of Technology"
  },

  {
    value: "Benson Idahosa University",
    text: "Benson Idahosa University"
  },

  {
    value: "Benue State University",
    text: "Benue State University"
  },

  {
    value: "Bowen University",
    text: "Bowen University"
  },

  {
    value: "Bukar Abba Ibrahim University",
    text: "Bukar Abba Ibrahim University"
  },

  {
    value: "Caleb University",
    text: "Caleb University"
  },

  {
    value: "Caritas University",
    text: "Caritas University"
  },

  {
    value: "CETEP City University",
    text: "CETEP City University"
  },

  {
    value: "City University",
    text: "City University"
  },

  {
    value: "City University of Technology",
    text: "City University of Technology"
  },

  {
    value: "Covenant University",
    text: "Covenant University"
  },

  {
    value: "Crawford University, Ogun",
    text: "Crawford University, Ogun"
  },
  {
    value: "Crawford University, Ekiti",
    text: "Crawford University, Ekiti"
  },
  {
    value: "Crescent University",
    text: "Crescent University"
  },

  {
    value: "Cross River University of Technology",
    text: "Cross River University of Technology"
  },

  {
    value: "Delta State University",
    text: "Delta State University"
  },

  {
    value: "Ebonyi State University",
    text: "Ebonyi State University"
  },

  {
    value: "BU",
    text: "BU"
  },

  {
    value: "Elizade University",
    text: "Elizade University"
  },

  {
    value: "Evangel University",
    text: "Evangel University"
  },

  {
    value: "Federal University Ndufe Alike",
    text: "Federal University Ndufe Alike"
  },

  {
    value: "Federal University of Agriculture",
    text: "Federal University of Agriculture"
  },

  {
    value: "Federal University of Technology",
    text: "Federal University of Technology"
  },

  {
    value: "Federal University Oye-Ekiti",
    text: "Federal University Oye-Ekiti"
  },

  {
    value: "Federal University, Dutsin-Ma",
    text: "Federal University, Dutsin-Ma"
  },

  {
    value: "Fountain University, Osogbo",
    text: "Fountain University, Osogbo"
  },

  {
    value: "Godfrey Okoye University",
    text: "Godfrey Okoye University"
  },

  {
    value: "Gregory University",
    text: "Gregory University"
  },

  {
    value: "Igbinedion University",
    text: "Igbinedion University"
  },

  {
    value: "International Open Institute",
    text: "International Open Institute"
  },

  {
    value: "Joseph Ayo Babalola University",
    text: "Joseph Ayo Babalola University"
  },

  {
    value: "Koladaisi University",
    text: "Koladaisi University"
  },

  {
    value: "Lagos State University",
    text: "Lagos State University"
  },

  {
    value: "Landmark University",
    text: "Landmark University"
  },

  {
    value: "Michael and Cecilia Ibru University",
    text: "Michael and Cecilia Ibru University"
  },

  {
    value: "Nasarawa State University",
    text: "Nasarawa State University"
  },

  {
    value: "National Open University of Nigeria",
    text: "National Open University of Nigeria"
  },

  {
    value: "Nigerian Turkish Nile University",
    text: "Nigerian Turkish Nile University"
  },

  {
    value: "Obafemi Awolowo University",
    text: "Obafemi Awolowo University"
  },

  {
    value: "Oduduwa University",
    text: "Oduduwa University"
  },

  {
    value: "Plateau State University",
    text: "Plateau State University"
  },

  {
    value: "Redeemer's University",
    text: "Redeemer's University"
  },

  {
    value: "Skyline University Nigeria",
    text: "Skyline University Nigeria"
  },

  {
    value: "Taraba State University",
    text: "Taraba State University"
  },

  {
    value: "Umaru Musa Yar'adua University",
    text: "Umaru Musa Yar'adua University"
  },

  {
    value: "University of Benin",
    text: "University of Benin"
  },

  {
    value: "University of Calabar",
    text: "University of Calabar"
  },

  {
    value: "University of Ibadan",
    text: "University of Ibadan"
  },

  {
    value: "University of Jos",
    text: "University of Jos"
  },

  {
    value: "University of Lagos",
    text: "University of Lagos"
  },

  {
    value: "University of Nigeria",
    text: "University of Nigeria"
  },

  {
    value: "University of Port Harcourt",
    text: "University of Port Harcourt"
  },

  {
    value: "Veritas University (Catholic University of Nigeria)",
    text: "Veritas University (Catholic University of Nigeria)"
  }
];
